export const MONSTERS = {
  mole: 'mole',
  treant: 'treant',
};
